"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoginForm_1 = __importDefault(require("./LoginForm"));
function SessionExpired(props) {
    return (react_1.default.createElement(LoginForm_1.default, { onSubmit: () => props.gotoLogin(), title: "You've been logged out" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, "Your login session has ended, please log in again."),
            "This might happen if:",
            react_1.default.createElement("ul", null,
                react_1.default.createElement("li", null, "You haven't logged in for a while"),
                react_1.default.createElement("li", null, "Your email address has been updated")),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", { className: "row row-10m" },
                react_1.default.createElement("div", { className: "col-xs-4 col-xs-offset-4 text-center" },
                    react_1.default.createElement("button", { type: "submit", className: "btn btn-login btn-action" }, "Back to Login"))))));
}
exports.default = SessionExpired;
